(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});
	};

	document.addEventListener('shopify:section:load', footer);
	footer();

	$(document).ready(function() {
		$('.icon-search').on('click', function(event) {
			event.preventDefault(); // Impede o redirecionamento
          $('.busca-nova').fadeIn();
           $('html').addClass("oh")
			
		});
	});

  $(document).ready(function() {
		$('.header__search a').on('click', function(event) {
			event.preventDefault(); // Impede o redirecionamento
          $('.busca-nova').fadeIn();
           $('html').addClass("oh")
			
		});
	});

  $(document).ready(function() {
		$('.close').on('click', function(event) {
          $('.busca-nova').fadeOut();
           $('html').removeClass("oh")
			
		});
	});


  

})();